import React from "react";
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';

export default class CreatePDF extends React.Component {
  render() {
    const items = this.props.CropSlabData || [];
    const searchData = this.props.SlabReportSearchData || {};

    return (
      <div style={{ width: '100%' }}>
        <h2 style={{ width: '100%' }}><center><u>COP Mapping Details Report</u></center></h2>
        <div>&nbsp;</div>
        <h3 style={{ width: '100%' }}><center>{searchData.groupName} - {searchData.factoryName}</center></h3>
        <h3 style={{ width: '100%' }}><center>{searchData.accountDescriptionTypeName && `COP Type: ${searchData.accountDescriptionTypeName}`}</center></h3>
        <h3 style={{ width: '100%' }}><center>{searchData.startDate} - {searchData.endDate}</center></h3>
        <div>&nbsp;</div>
        <div>
          <Box style={{ width: '100%' }}>
            <TableContainer style={{ width: '100%' }}>
              <Table aria-label="COP Mapping Table" size="small" style={{ width: '100%', tableLayout: 'fixed' }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ border: '1px solid black' }}>Voucher Number</TableCell>
                    <TableCell align="center" style={{ border: '1px solid black' }}>Date</TableCell>
                    <TableCell align="center" style={{ border: '1px solid black' }}>Account</TableCell>
                    <TableCell align="center" style={{ border: '1px solid black' }}>Description</TableCell>
                    <TableCell align="center" style={{ border: '1px solid black' }}>Credit</TableCell>
                    <TableCell align="center" style={{ border: '1px solid black' }}>Debit</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell align="left" style={{ border: '1px solid black' }}>{row.vno}</TableCell>
                      <TableCell align="center" style={{ border: '1px solid black' }}>
                        {row.date ? row.date.substring(0, 10) : ""}
                      </TableCell>
                      <TableCell align="left" style={{ border: '1px solid black' }}>{row.account}</TableCell>
                      <TableCell align="left" style={{ border: '1px solid black' }}>{row.description}</TableCell>
                      <TableCell align="right" style={{ border: '1px solid black' }}>{Number(row.credit || 0).toFixed(2)}</TableCell>
                      <TableCell align="right" style={{ border: '1px solid black' }}>{Number(row.debit  || 0).toFixed(2)}</TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell colSpan={4} align="left" style={{ border: '1px solid black' }}>Total</TableCell>
                    <TableCell align="right" style={{ border: '1px solid black' }}>{items.reduce((sum, row) => sum + (Number(row.credit) || 0), 0).toFixed(2)}</TableCell>
                    <TableCell align="right" style={{ border: '1px solid black' }}>{items.reduce((sum, row) => sum + (Number(row.debit) || 0), 0).toFixed(2)}</TableCell>
                  </TableRow>
                  {items.length === 0 &&
                    <TableRow>
                      <TableCell align="center" colSpan={6} style={{ borderBottom: "none" }}>
                        No data found
                      </TableCell>
                    </TableRow>
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
        <div>&nbsp;</div>
        <h3 style={{ width: '100%' }}>
          <center>***** End of List *****</center>
        </h3>
      </div>
    );
  }
}
